export const libConfig = {
  tag: 'data-slide-toggle',
  values: {
    hidden: 'hidden',
    visible: 'shown',
  },
} as const;
